import styled from 'styled-components'

const Label = styled.label`
  color: #2b2b2b;
  font-size: 16px;
`

export { Label }
